import React from 'react'
import { Navigate, Outlet } from 'react-router';

const ProtectedRouts = () => {
    const user = sessionStorage.getItem('sessionId');
    return user ? <Outlet/> : <Navigate  to={'/'}/>
}

export default ProtectedRouts